import HeaderWithActions, {
  CustomButtonProps,
} from 'lib/designSystem/HeaderWithActions';
import TableWithPagination from 'lib/designSystem/TableWithPagination';
import { Warranty } from 'lib/types/models';
import { Pagination } from 'lib/types/shared';
import React from 'react';

interface WarrantiesTableProps {
  warranties: Warranty[];
  setWarranties: (warranties: Warranty[]) => void;
  setOpenCreateDialog?: (open: boolean) => void;
  handleOpenWarrantyDetail: (warrantyId: number) => void;
  pagination: Pagination;
  setPagination: (pagination: Pagination) => void;
  fetchWarranties: () => Promise<void>;
  setIsLoading: (isLoading: boolean) => void;
  showBusinessName?: boolean;
}

const WarrantiesTable = ({
  warranties,
  setWarranties,
  setOpenCreateDialog,
  handleOpenWarrantyDetail,
  pagination,
  setPagination,
  fetchWarranties,
  setIsLoading,
  showBusinessName = true,
}: WarrantiesTableProps) => {
  const tableHeaders = [
    {
      label: 'ID',
      key: 'id',
      type: 'numeric-id',
    },
    {
      label: 'Tipo',
      key: 'translatedType',
    },
    ...(showBusinessName
      ? [
          {
            label: 'Cliente',
            key: 'businessName',
          },
        ]
      : []),
    {
      label: 'Estado',
      key: 'translatedStatus',
      type: 'status',
    },
    {
      label: 'Monto Cotizado',
      key: 'quotedAmount',
      type: 'money',
    },
    {
      label: 'Moneda',
      key: 'quotedCurrency',
    },
    {
      label: 'Fecha Cotización',
      key: 'quoteDate',
      type: 'date',
    },
    {
      label: 'Fecha Inicio',
      key: 'startDate',
      type: 'date',
    },
    {
      label: 'Fecha Término',
      key: 'endDate',
      type: 'date',
    },
  ];

  const buttons: CustomButtonProps[] = setOpenCreateDialog
    ? [
        {
          name: 'Nueva Garantía',
          color: 'primary',
          action: () => setOpenCreateDialog?.(true),
        },
      ]
    : [];

  return (
    <div style={{ marginTop: '20px', marginBottom: '20px' }}>
      <HeaderWithActions
        title="Lista de garantías emitidas y cotizaciones realizadas"
        variant="body1"
        buttons={buttons}
      />
      <TableWithPagination
        data={warranties}
        setData={setWarranties}
        dataHeaders={tableHeaders}
        handleClickRow={handleOpenWarrantyDetail}
        showActions
        pagination={pagination}
        setPagination={setPagination}
        searchData={fetchWarranties}
        setLoading={setIsLoading}
        exportToFile="xlsx"
        lastElement
      />
    </div>
  );
};

export default WarrantiesTable;
